<template>
    <div>
        <v-layout row wrap justify-center>
              <v-flex xs12 sm7 md7 >
                  <dialogos-app :dialogos="dialogosRegion" tucan="0"></dialogos-app>
              </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center mt-4>
            <v-flex xs12 sm7 md7 class="cont-img">
                <video :src="url" buffered controls 
                       :width="widthVideo" 
                       controlslist="nodownload"
                       @ended="$store.commit('nextShow',true)" 
                ></video>
            </v-flex>
        </v-layout>        
    </div>
</template>

<script>
export default {
    data(){
        return {
            dialogosRegion:[
                'A Região Centro-Oste tem 3 estados: Goiás, Mato Grosso e Mato Grosso do Sul.',
                'Nesta região, encontra-se Brasília, a capital do Brasil. Clique no vídeo e assista.'
            ],
            widthVideo:'100%',
            url:  'videos/ibraco-presentacion-2.mp4',
        }
    }
}
</script>